import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../landing.module.scss';
import dashboardImg from '../../../assets/images/landing/hero-dashboard.png';
import GlobalSearchBar from '../../../components/Common/GlobalSearchBar';

// Login Redirect Utility
import { navigateToLogin, navigateToRegister } from '../../../utils/loginRedirect';

const HeroSection = () => {
    const location = useLocation();
    const navigate = useNavigate();

    return (
        <section className={styles.heroSection}>
            <div className={styles.container}>
                <div className={styles.heroContent}>
                    <h1>KeyQuest, <br />Your all-in-one VR <br />Market intelligence tool</h1>
                    <p>
                        Discover revenue trends, track competitors, analyze keywords, and boost
                        your game’s visibility with complete insights into the Meta Quest market.
                    </p>
                    <div className={styles.heroSearch}>
                        <GlobalSearchBar placeholder="Search apps, games..." />
                    </div>
                    <div className={styles.heroButtons}>
                        {/* Primary CTA */}
                        <button
                            onClick={() => navigateToRegister(location.pathname, navigate)}
                            className={`${styles.btn} ${styles.btnPrimary}`}
                        >
                            Get Started
                        </button>

                        {/* Secondary / Ghost CTA */}
                        {/* <button className={`${styles.btn} ${styles.btnSecondary}`}>
                            <span className={styles.playIcon}>▶</span>
                            Watch Video
                        </button> */}
                    </div>

                </div>
                <div className={styles.heroImageWrapper}>
                    {/* Placeholder for the dashboard image */}
                    <div className={styles.dashboardMockup}>
                        {/* <div className={styles.mockupHeader}>
                            <span>KeyQuest</span>
                            <div className={styles.mockupControls}></div>
                        </div> */}
                        <iframe
                            width="100%"
                            height="100%"
                            src="https://www.youtube.com/embed/TscOxyJRt-k?autoplay=1&mute=1&loop=1&playlist=TscOxyJRt-k&rel=0"
                            title="KeyQuest VR Intelligence"
                            frameBorder="0"
                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>
            </div>

            {/* Background Gradients/Blobs */}
            <div className={styles.heroBlobLeft}></div>
        </section>
    );
};

export default HeroSection;
